module.exports = __webpack_public_path__ + "img/Mascot_sante.a154630d.png";